import { useEffect } from "react";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE_KEY = "gh_utm";

export function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const incoming = {};

  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) incoming[key] = value.toLowerCase().trim();
  });

  // Grava apenas na primeira chegada com UTM (atribuição first-touch).
  // Para last-touch, remover a verificação de existência do storage.
  if (Object.keys(incoming).length > 0 && !sessionStorage.getItem(STORAGE_KEY)) {
    incoming.first_landing_page = window.location.pathname;
    incoming.captured_at = new Date().toISOString();
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(incoming));
  }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export function useUtmCapture() {
  useEffect(() => {
    captureUtm();
  }, []);
}
